var a = /* @__PURE__ */ ((r) => (r.CONTAINER = "container", r.PAGE = "page", r.ROOT = "app", r.PAGE_FRAGMENT = "page-fragment", r))(a || {}), E = /* @__PURE__ */ ((r) => (r.COMP = "comp", r.CODE = "code", r.DATA_SOURCE = "data-source", r))(E || {}), O = /* @__PURE__ */ ((r) => (r.CODE = "code", r))(O || {});
export {
  E as ActionType,
  O as HookType,
  a as NodeType
};
